import * as React from "react";
const SvgFiRrRecycle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-recycle_svg__a)">
      <path
        fill="#062147"
        d="m10.357 2.921-1.416 2.3a1 1 0 0 1-1.7-1.048l1.416-2.3a3.948 3.948 0 0 1 6.692 0l4.2 6.834.441-2.365a1 1 0 0 1 1.967.366l-.5 2.67a3 3 0 0 1-2.942 2.451c-.195 0-3.217-.576-3.217-.576a1 1 0 0 1 .386-1.962l2.133.421-4.174-6.791a1.934 1.934 0 0 0-3.286 0M23.41 14.98l-.968-1.572a.999.999 0 1 0-1.7 1.048l.968 1.572a1.93 1.93 0 0 1 .041 1.98 1.91 1.91 0 0 1-1.688.992h-7.386l1.271-1.269a1 1 0 0 0-1.412-1.416L10.843 18A2.86 2.86 0 0 0 10 19.98v.034a2.89 2.89 0 0 0 .855 2.071l1.682 1.652a1 1 0 1 0 1.4-1.427L12.61 21h7.453a3.948 3.948 0 0 0 3.347-6.02M6.78 7.213a2.98 2.98 0 0 0-2.263-.46l-2.629.518a1 1 0 1 0 .386 1.962l2.108-.415-3.79 6.162A3.948 3.948 0 0 0 3.936 21H7.08a1 1 0 1 0 0-2H3.937a1.91 1.91 0 0 1-1.684-.992 1.93 1.93 0 0 1 .041-1.98L6.132 9.79l.446 2.394a1 1 0 1 0 1.967-.368l-.5-2.67A2.99 2.99 0 0 0 6.78 7.213"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-recycle_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrRecycle;
